import Vue from 'vue';

class StatusService {
  changeStatus(id) {
    return new Promise((res, rej) => {
      if (id !== Vue.prototype.$store.currentStatus) {
        const deviceId = Vue.prototype.$store.deviceStartData.device.device_id;
        Vue.prototype.$crudService.put(`device/operator-workspaces/${deviceId}/change-status/${id}`).then(({data}) => {
          this.writeStatus(id, data);
          Vue.prototype.$eventEmitter.emit(Vue.prototype.$eventEmitter.eventTypes.STATUS_CHANGE);
          res(id)
        }).catch((err) => rej(err));
      }
    })
  }

  writeStatus(id, timestamp) {
    Vue.prototype.$store.currentStatus = id;
    if (timestamp) Vue.prototype.$store.currentStatusTimestamp = timestamp;
  }
}

export default StatusService;
